<template>
  <div>
    <label :for="id">{{label}}</label>
    <input :class="vclass" type="text" :id="id" class="datepicker" ref="picketDocument">
    <span class="helper-text" :data-error="verror" :data-success="vsuccess"></span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pickerInstance: null,
      id: null
    };
  },
  props: {
    options: Object,
    label: String,
    value: Date,
    vclass: Object,
    verror: String,
    vsuccess: String
  },
  mounted() {
    this.id = `picker${this._uid}`;
    const onClose = this.options.onClose;
    const vueInstance = this;
    this.options.onClose = function() {
      vueInstance.$emit("input", this.date);
      vueInstance.$emit("touch");
      if (onClose) onClose();
    };
    if (!this.options) this.options = {};
    this.options.i18n = {
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      monthsShort: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic"
      ],
      weekdays: [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado"
      ],
      weekdaysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      selectMonths: true,
      selectYears: 100, // Puedes cambiarlo para mostrar más o menos años
      today: "Hoy",
      clear: "Limpiar",
      cancel: "Cancelar",
      done: "OK",
      weekdaysAbbrev:	['D','L','M','Mi','J','V','S'],
      labelMonthNext: "Siguiente mes",
      labelMonthPrev: "Mes anterior",
      labelMonthSelect: "Selecciona un mes",
      labelYearSelect: "Selecciona un año"
    };
    console.log(this.options);
    this.pickerInstance = M.Datepicker.init(
      this.$refs.picketDocument,
      this.options
    );
  },
  computed: {},
  watch: {
    value(value) {
      if (value == null) {
        this.pickerInstance.el.value = "";
      }
    }
  }
};
</script>
<style scoped>
canvas svg circle {
  background: var(--primary-color);
}
</style>

